import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
import { getAllowedProductIds as getAllowedProductIdsShared } from "ah_utility/fnxUtils";
import { APAP_AUTO_SUBDOMAIN, DEFAULT_CHECKED_STATUS_KEYWORDS, } from "../constants/insurancePoliciesSummary.constants";
export var isApapAutoSubdomain = function () {
    return findParamInLocalStorage("subdomain") === APAP_AUTO_SUBDOMAIN;
};
export var getDefaultCheckedStatusItems = function (statusOptions) {
    if (!isApapAutoSubdomain())
        return [];
    return statusOptions.filter(function (item) {
        return DEFAULT_CHECKED_STATUS_KEYWORDS.some(function (keyword) { var _a; return (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(keyword); });
    });
};
export var getAllowedProductIds = function () {
    return getAllowedProductIdsShared(APAP_AUTO_SUBDOMAIN);
};
export var getDefaultProjectIds = function () {
    var allowedProductIds = getAllowedProductIds();
    return allowedProductIds ? allowedProductIds.join(",") : "";
};
export var hasProductPermissionRestriction = function () {
    return getAllowedProductIds() !== null;
};
